{
  "links": {
    "classes": "Classes",
    "classes_description": "View your classes",
    "profile": "Profile",
    "profile_description": "View or edit your profile"
  }
}
